/**
 * Tools Availability page for endusers
 * Uses shared AvailabilitySearch component
 */
import { createRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { toolsRoute } from './index'
import { AvailabilitySearch } from '@/components/amadeus'

function ToolsAvailabilityPage() {
  const navigate = useNavigate()

  return (
    <div className="max-w-6xl mx-auto">
      {/* Back button */}
      <button
        onClick={() => navigate({ to: '/tools' })}
        className="flex items-center gap-2 text-slate-500 hover:text-slate-700 mb-6 transition-colors"
      >
        <ArrowLeft className="h-4 w-4" />
        Zurück zur Übersicht
      </button>

      <AvailabilitySearch seatmapPath="/tools/seatmap" />
    </div>
  )
}

export const toolsAvailabilityRoute = createRoute({
  getParentRoute: () => toolsRoute,
  path: '/availability',
  component: ToolsAvailabilityPage,
})
